import { refundRepository } from '~/api/repository/refund';

export const REFUND_QUERY_KEY = {
  all: ['refund'] as const,

  // 환불 계좌 조회 (useOAIQuery와 동일한 queryKey 사용)
  account: () => ({
    queryKey: ['/api/market-place/v1/payments/refund-account'] as const,
    queryFn: () => refundRepository.getRefundAccount(),
  }),

  // 환불 은행 목록 조회 (useOAIQuery와 동일한 queryKey 사용)
  bankList: () => ({
    queryKey: ['/api/market-place/v1/payments/kpn/vacct/bank-refund'] as const,
    queryFn: () => refundRepository.getRefundBankList(),
  }),
};

// Mutation Keys (캐시 무효화에 사용)
export const REFUND_MUTATION_KEY = {
  updateAccount: () => [...REFUND_QUERY_KEY.all, 'update'] as const,
  validateAccountHolder: () => [...REFUND_QUERY_KEY.all, 'validate'] as const,
  checkAccount: () => [...REFUND_QUERY_KEY.all, 'check'] as const,
};
